import { StringType } from "./strings";

const STRING_UA: StringType = {
  translation: {
    general: {
      loading: "завантаження...",
    },
    burgerMenu: {
      dutyPlan: "план обов'язків",
      dashboard: "панель",
      lights: "освітлення",
      jokeOfTheDay: "смішнявка дня",
      settings: "налаштування",
      deliveryDriver: "кур'єр",
      wifi: "Wi-Fi",
      camera: "камера",
      images: "зображення",
      scavengerhunt: "СЛАВА УКРАЇНІ!!!!",
    },
    dutyCard: {
      tasks: "завдання",
      tasksInDetail: "Детальні завдання",
      everyWeek: "щотижня",
      everyXWeeks_one: "кожен {{count}} тиждень",
      everyXWeeks_other: "кожні {{count}} тижні",
      day_one: "{{count}} день",
      day_other: "{{count}} днів",
    },
    trashCalendar: {
      title: "утилізація сміття",
    },
    duties: {
      bathroom: {
        name: "сральник",
        quote: "хто обсиратиме унітаз — матиме понос!",
        generalTasks: {
          bathroom: "сральник",
          trash: "сміття",
        },
        detailedTasks: {
          cleanToilet: "помити сральник",
          cleanSink: "помити раковину",
          cleanShower: "помити душ",
          cleanFurniture: "витерти полиці",
          disposeTrash: "викинути сміття",
          disposeCompost: "викинути компост",
        },
      },
      floor: {
        name: "підлога",
        quote: "підлога тримає нас вічно!",
        generalTasks: {
          livingRoom: "вітальня",
          floor: "підлога",
          glasAndCans: "скло та бляшанки",
        },
        detailedTasks: {
          cleanSofa: "почистити диван",
          lamps: "пампи",
          vacuumClean: "пропипососити",
          wipeFloor: "протерти підлогу",
          disposeGlasAndCans: "утилізувати скло та бляшанки",
          waterPlants: "полити рослини",
        },
      },
      kitchen: {
        name: "кухня",
        quote: "без El Tony навіть найкращий нічого не зможе!",
        generalTasks: {
          kitchen: "кухня",
          petAndPlasticBottles: "пляшки PET і пластик",
          cardboardAndPaper: "картон і папір",
        },
        detailedTasks: {
          cleanStoveTableAndSink: "помити плиту, стіл і раковину",
          cleanSurfaces: "помити поверхні",
          cleanTrashCabinet: "помити сміттєвий бак",
          cleanSteamExhaust: "помити витяжку",
          disposeCardboardAndPaper: "утилізувати картон і папір",
          disposePetAndPlasticBottles: "утилізувати PET та пластикові пляшки",
        },
      },
    },
    weatherCodes: {
      sunny: "сонячно",
      clear: "ясно",
      mainlySunny: "переважно сонячно",
      mainlyClear: "переважно ясно",
      partlyCloudy: "мінлива хмарність",
      cloudy: "хмарно",
      foggy: "туманно",
      rimeFog: "іній, туман",
      lightDrizzle: "легкий дощ",
      drizzle: "дрібний дощ",
      heavyDrizzle: "єбанутий дощ",
      lightFreezingDrizzle: "ізі крижаний дощ",
      freezingDrizzle: "крижаний дощ",
      lightRain: "легкий дощ",
      rain: "дощ",
      heavyRain: "сильний дощ",
      lightFreezingRain: "ізі крижаний дощ",
      freezingRain: "крижаний дощ",
      lightSnow: "ізі сніг",
      snow: "сніг",
      heavySnow: "єбанутий сніг",
      snowGrains: "снігові крупиці",
      lightShowers: "легкі зливи",
      showers: "зливи",
      heavyShowers: "сльні зливи",
      lightSnowShowers: "ізі снігопади",
      snowShowers: "снігопади",
      thunderstorm: "гроза",
      lightThunderstormsWithHail: "ізі гроза з градом",
      thunderstormWithHail: "гроза з градом",
    },
    deliveryDrivers: {
      orderedOn: "замовлено",
      order: "замовлення:",
    },
    camera: {
       done: "готово!УРА!!!",
      imagePreviewInfoText: "зображення можна переглянути на сторінці зображень",
    },
    settings: {
      language: "мова",
      theme: "тема",
      reload: "перезавантажити сайт",
    },
  },
};

export default STRING_UA;
